import React, { Component } from 'react'
import { connect } from "react-redux";
import { Link, withRouter } from 'react-router-dom'

import userManager from '../utils/userManager'

class NavBar extends Component {
  onLoginButtonClick(e) {
    e.preventDefault()
    userManager.signinRedirect()
  }
  
  onLogoutButtonClick(e) {
    e.preventDefault()
    userManager.removeUser()
  }
  
  render () {
    const loggedIn = this.props.loggedIn
    const user = this.props.user
    
    if (!loggedIn) {
      return (
        <nav className="navbar navbar-dark bg-primary fixed-top">
          <Link className="navbar-brand" to="#">
            Things API
          </Link>
          <button className="btn btn-dark" onClick={ this.onLoginButtonClick } >Login</button>
        </nav>
      );
    }
    
    return (
      <nav className="navbar navbar-dark bg-primary fixed-top justify-content-between navbar-expand-lg">
        <Link className="navbar-brand" to="#">
          Things API
        </Link>
        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown">
          <span className="navbar-toggler-icon"></span>
        </button>
        
        <div className="collapse navbar-collapse" id="navbarNavDropdown">
          <ul className="navbar-nav">
            <li className="nav-item active">
              <Link className="nav-link" to="/">Home</Link>
            </li>
            <li className="nav-item active">
              <Link className="nav-link" to="/assets">Assets</Link>
            </li>
            <li className="nav-item active">
              <Link className="nav-link" to="/sensors">Sensors</Link>
            </li>
            
          </ul>
        </div>
        
        <span className="float-right">
          <span className="mr-2 text-white" >Logged in as {user.profile.name} ({user.profile.email})</span>
          <button className="btn btn-dark" onClick={ this.onLogoutButtonClick } >Logout</button>
        </span>
      </nav>
    );
  }
}

const mapStateToProps = state => ({
  user: state.oidc.user,
  loggedIn: state.oidc.user && !state.oidc.user.expired
});

export default connect(
  mapStateToProps,
)(withRouter(NavBar));